/* RESPONSIBLE TEAM: team-ai-agent-2 */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class PermittedTheme extends Fragment {
  @attr('string') declare name: string;
  @attr('string') declare description: string;
}
